<link rel="stylesheet" href="/aragon.css" />
<!-- Sidenav -->
<div class="" (window:resize)="isMobile($event)">
    <app-admin-sidebar [ngClass]="{ 'sidenav fixed-left': !isMobileResolution }"></app-admin-sidebar>
    <div class="main-content">
        <!-- Top navbar -->
        <app-admin-navbar></app-admin-navbar>
        <!-- Pages -->
        <router-outlet></router-outlet>
        <app-admin-footer></app-admin-footer>
    </div>
</div>
